import { AbstractMesh } from '@babylonjs/core'
import { Vector3 } from '@babylonjs/core/Maths/math.vector'
import { TransformNode } from '@babylonjs/core/Meshes/transformNode'
import Part from './Part'

export default class Bridge extends Part {
	public NosepadOutRight: TransformNode
	public NosepadOutLeft: TransformNode

	public LensOutLeft: TransformNode
	public LensOutRight: TransformNode

	constructor(parent: TransformNode, mirror: boolean = false) {
		super('BRIDGE', parent, mirror)

		this.attachmentPoints.set('NOSEPAD-OUT-RIGHT', this.NosepadOutRight = new TransformNode('NOSEPAD-OUT-RIGHT', parent.getScene()))
		this.attachmentPoints.set('NOSEPAD-OUT-LEFT', this.NosepadOutLeft = new TransformNode('NOSEPAD-OUT-LEFT', parent.getScene()))

		this.attachmentPoints.set('LENS-OUT-RIGHT', this.LensOutRight = new TransformNode('LENS-OUT-RIGHT', parent.getScene()))
		this.attachmentPoints.set('LENS-OUT-LEFT', this.LensOutLeft = new TransformNode('LENS-OUT-LEFT', parent.getScene()))

		this.NosepadOutRight.parent = this.NosepadOutLeft.parent = this
		this.LensOutRight.parent = this.LensOutLeft.parent = this
	}

	override get filename(): string {
		return this.config.components.BRIDGE ? `Bridges/${this.isPrecious ? 'Precious' : 'Titanium'}/${[this.config.components.BRIDGE.design, this.config.components.BRIDGE.size].filter(Boolean).join(' ')}` : null
	}

	override get isPrecious(): boolean {
		return this.config.components.BRIDGE?.color?.startsWith('AU750') || this.config.components.BRIDGE?.color?.startsWith('PT950')
	}

	override getMeshMaterialName(mesh: AbstractMesh): string {
		if (mesh.name == 'BRIDGE') {
			return this.config.components.BRIDGE.color
		} else {
			throw (`Unexpected ${this.name} mesh: (${mesh.name})`)
		}
	}

	override swap(animated: boolean = false) {
		super.swap(animated)
		this.position = new Vector3(0, -this.LensOutLeft.position.y, -this.LensOutLeft.position.z)
		// if(this.config.components.BRIDGE?.color) this.getChildMeshes(true, x=>x.name == "BRIDGE").map(x => x.material = this.getScene().getMaterialByName(this.config.components.BRIDGE.color))

		// this.getComponentMeshes("BRIDGE", ).flat().forEach(mesh => this.assignMaterial(mesh, this.config.components["BRIDGE"]?.color))
	}
}
